import React from 'react';
import Challenge from '../Challenge/Challenge';
import Fitness from '../Fitness/Fitness';
import Services from '../Services/Services/Services';

const AllServicess = () => {
    return (
        <div>
            <Fitness></Fitness>
            <Services></Services>
            <Challenge></Challenge>
        </div>
    );
};

export default AllServicess;